import { Suspense } from 'react';
import { Chart as ChartJS, registerables } from 'chart.js';
import 'chart.js/auto';
import './App.css';

import { AuthProvider } from './contexts/AuthContext';
import { AppRouterProvider } from './AppRouterProvider';
import { Spinner } from 'react-bootstrap';

const Loader = () => {
  return (
    <div className="crt-app-loader d-flex justify-content-center align-items-center h-100">
      <Spinner />
      <span className="theme-text loader-text">Loading...</span>
    </div>
  );
};

function App() {
  ChartJS.register(...registerables);

  return (
    <AuthProvider>
      <Suspense fallback={<Loader />}>
        <AppRouterProvider />
      </Suspense>
    </AuthProvider>
  );
}

export default App;
